import type { NectarPageBlock } from '~/utils/nectarPageBlock';
import { withNectarTrackingParams } from '~/utils/nectarTracking';

import { useCommunityFeedActionMutation } from './useCommunityFeedActionMutation';

const FOLLOW_MEMBER_ACTION = '/community_member_follow';

interface FollowMemberVars {
  memberId: string;
  follow: boolean;
  pageBlock?: NectarPageBlock;
}

export const useFollowMemberMutation = () =>
  useCommunityFeedActionMutation<FollowMemberVars>({
    buildRequest: ({ memberId, follow, pageBlock }) => ({
      path: FOLLOW_MEMBER_ACTION,
      fields: withNectarTrackingParams({ member_id: memberId, action_type: follow ? 'follow' : 'unfollow' }, pageBlock),
    }),
  });
